import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["userNotes.attachments"],
  attachments => attachments
);
